module.exports = __webpack_public_path__ + "img/orbit-card-total-rewards.b9865332.png";